<template>
  <div class="prepare-exam__sidebar">
    <div class="prepare-exam__sidebar__info">
      <div class="prepare-exam__sidebar__actions display-flex-center justify-content-between">
        <button
          type="submit"
          class="prepare-exam__sidebar__save btn btn-gray border-rd-20 font-sanpro-semibold font-size-17 primary-color display-flex-center justify-content-center"
          @click.prevent="handleSaveExam"
        >
          Lưu đề thi
        </button>
        <div class="prepare-exam__sidebar__actions_other display-flex-center">
          <a
            href="javascript:;" 
            class="prepare-exam__sidebar__view btn btn-gray border-rd-50 display-flex-center justify-content-center"
            v-b-tooltip.hover title="Xem đề thi"
            @click="viewExam"
          >
            <i class="icon-eye font-size-20"></i>
          </a>
          <b-dropdown class="prepare-exam__sidebar__more" id="side-bar__more">
            <template #button-content>
              <a href="javascript:;" class="btn btn-gray border-rd-50 display-flex-center justify-content-center">
                <i class="icon-more font-size-18"></i>
              </a>
            </template>
            <!-- <b-dropdown-item v-if="examInfo.examId" href="javascript:;" @click="onExportPdf()">Tải xuống</b-dropdown-item> -->
            <b-dropdown-item href="javascript:;" @click="deleteExam()">Xóa đề thi</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
      <a
        href="javascript:;"
        class="font-size-17 prepare-exam__sidebar__sub secondary-color-txt"
        @click.prevent="handleViewExamInfo"
        :class="{'active': indexQuestionWorking === -1}"
      >
        Thông tin đề thi
      </a>
      <a
        href="javascript:;"
        class="prepare-exam__sidebar__add-question font-size-17 secondary-color-txt display-flex-center"
        @click="addNewQuestion()"
      > <!-- addNewQuestion is function of mixinsCreateQuestion -->
        <i class="icon-plus secondary-color-txt"></i> 
        Thêm câu hỏi
      </a>
    </div>
    <div id="sidebar__questions" class="prepare-exam__sidebar__questions__scroll position-rel custom-scroll" :settings="{maxScrollbarLength: 300}">
      <ul class="prepare-exam__sidebar__questions margin-0 p-0">
        <li
          v-for="(item, index) of questionList"
          :key="index"
          @click="handleWorkingQuestionDetail(item, index)"
          :id="`question_sidebar_${index}`"
          class="cursor-pointer"
          :class="{'active': indexQuestionWorking === index}"
        >
          {{ item.title }}
        </li>
      </ul>
    </div>
    <a href="javascript:;" class="font-size-17 primary-color prepare-exam__sidebar__guide" @click="openModalGuidePrepare">Hướng dẫn soạn đề</a>
    <div class="show-document" v-if="visiblePreviewModal">
        <div class="inner-content js-model active">
          <ModalPreviewDocMedia />
          <div class="js-background-model active" @click="handleOffModal"></div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
// import * as html2pdf from 'html2pdf.js'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { STORE_KEY, BASE_64_DEFINE } from './../../_store/constants'
// import { TYPE_RADIO, TYPE_CHECKBOX } from '@/modules/question/preview-question/_store/constants'
import { apiCreateExam, apiUpdateExam, apiExamDelete } from './../../_api/exam'
import ModalPreviewDocMedia from '@/components/content-files/ModalPreviewDocMedia.vue'
import { scrollTo } from '@/helpers/functions';
import mixinsFiles from '@/components/content-files/mixinsFiles'
import mixinsCreateQuestion from './../../_store/mixinsCreateQuestion'
import { APP_CONFIG } from '@/utils/constants'

export default {
  name: 'Sidebar',
  mixins: [ mixinsFiles, mixinsCreateQuestion ],
  components: {
    ModalPreviewDocMedia,
    vueCustomScrollbar
  },
  data () {
    return {
      apiUrl: APP_CONFIG.appUrl
    }
  },
  computed: {
    ...mapState('common', ['visiblePreviewModal']),
    ...mapState(STORE_KEY, ['examInfo', 'questionList', 'indexQuestionWorking']),
    examId () {
      return parseInt(this.$route.params.id)
    }
  },
  methods: {
    ...mapActions('common', ['setLoading', 'setDocPreviewContent', 'toggleModalPreview']),
    ...mapActions(STORE_KEY, ['acSetExamPrepareInfo']), //, 'acSetListQuestions', 'acSetQuestionIndexWorking', 'acSetQuestionDetail'

    viewExam () {
      if(this.examId > 0){
        this.$router.push('/xem-de-thi/' + this.examId)
      } else{
        this.$toast.error('Vui lòng lưu đề thi trước')
      }
    },

    async handleSaveExam () {
      // console.log('Submit data: ', this.questionList);
      this.$emit('onSubmit', true)
      // let elImgFeature = document.getElementById('prepare_question_view')
      // if (!elImgFeature) {
      //   return
      // }
      // this.setLoading(true)
      // let options = { type: "dataURL" }
      // let imageBase64 = await this.$html2canvas(elImgFeature, options)
      // imageBase64 = imageBase64.replace(BASE_64_DEFINE, '')
      // let questionIds = []
      // if (this.questionList && this.questionList.length > 0) {
      //   this.questionList.map(ques => {
      //     ques.questionId && ques.questionId > 0 && questionIds.push(ques.questionId)
      //   })
      // }
      // // await this.acSetExamPrepareInfo({ ...this.examInfo, imageBase64, examTypeId:1, questions: questionIds })
      // console.log('AAAAAA: ', { ...this.examInfo, imageBase64, examTypeId:1, questions: this.questionList });
      // await this.acSetExamPrepareInfo({ ...this.examInfo, imageBase64, examTypeId:1, questions: this.questionList })
      // if (!this.examInfo.examId || this.examInfo.examId === 0) {
      //   this.createExam()
      // } else {
      //   this.updateExam()
      // }
    },

    // createExam () {
    //   let self = this
    //   apiCreateExam(this.examInfo).then(res =>{
    //     if (res && res.data && !res.errors) {
    //       self.$toast.success('Tạo đề thi thành công!')
    //       self.$router.push({ name: "examList" })
    //     }
    //   }).finally(() => self.setLoading(false))
    // },

    // updateExam () {
    //   let self = this
    //   apiUpdateExam(this.examInfo).then(res => {
    //     if (res && res.data && !res.errors) {
    //       self.$toast.success('Cập nhật đề thi thành công!')
    //       self.$router.push({ name: "examList" })
    //     }
    //   }).finally(() => self.setLoading(false))
    // },

    deleteExam () {
      apiExamDelete({id: this.examId}).then(res =>{
        this.$toast.success('Xóa thành công')
        this.$router.push({ name: "examList" })
      })
    },
    
    // addNewQuestion () {
    //   let questions = this.questionList
    //   let questionLength = questions.length
    //   let questionNew = {questionId: 0, isNew: true, title: `Câu ${questionLength + 1}`, content: '', answers: [], guideContent: '',suggestion: '', answerDetail: '', layoutId: 1, type: TYPE_RADIO}
    //   questions.push(questionNew)
    //   this.acSetListQuestions(questions)
    //   this.handleWorkingQuestionDetail(questionNew, questionLength)
    // },

    // setScrollToCat(index) {
    //   let elem = document.getElementById(`question_sidebar_${index}`);
    //   if(elem) {
    //     let topPos = elem.offsetTop;
    //     scrollTo(document.getElementById('sidebar__questions'), topPos, 600);
    //   }
    // },

    // handleWorkingQuestionDetail (data, index) {
    //   this.resetQuestionWorking()
    //   if (data.type === TYPE_CHECKBOX) {
    //     data['multiCorrectCheckbox'] = []
    //   }
    //   data.answers && data.answers.map((ans, index) => {
    //     if(ans.correct ) {
    //       ans['answerContent'] = ans.orderNo
    //       data.type === TYPE_CHECKBOX && data.multiCorrectCheckbox.push(ans.orderNo)
    //     }
    //   })
    //   this.acSetQuestionDetail(data)
    //   setTimeout(() => {
    //     this.acSetQuestionIndexWorking(index)
    //     this.setScrollToCat(index)
    //   }, 100)
    // },

    handleViewExamInfo () {
      this.resetQuestionWorking()
    },

    // resetQuestionWorking () {
    //   this.acSetQuestionDetail({})
    //   this.acSetQuestionIndexWorking(-1)
    // },

    openModalGuidePrepare () {
      this.setDocPreviewContent({type: 'prepare-exam', path: '', isLocal: true, linkViewFull: true, name: 'Hướng dẫn soạn đề', bookInfo: {fileName: 'prepare-exam/prepare-exam-guide', totalPage: 3}});
      this.toggleModalPreview(true)
    },

    handleOffModal () {
      this.toggleModalPreview(false)
      this.setDocPreviewContent({})
    },

    onExportPdf () {
      this.examInfo.urlPDF && this.downloadDocs(`${this.apiUrl}/${this.examInfo.urlPDF}`, this.examInfo.name, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.prepare-exam__sidebar__questions__scroll {
  max-height: 300px;
  overflow-y: auto;
  margin-bottom: 20px;
}
</style>
